import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Geometry } from 'geojson';
import { AuthService } from '../../auth/auth.service';
import { AutomationService } from '../../automation/automation.service';
import { TooltipDirective } from '../../components/qm-directives/tooltip-directive/tooltip.directive';
import { MapElement } from '../../shared/map/map-element.model';
import { MapService } from '../../shared/map/map.service';
import { AlarmMessage } from '../alarm-message';
import { AlarmService } from '../alarm.service';
import { isAlarmActiveForUser } from '../alarm.utils';

@Component({
  selector: 'qm-alarm-item-menu',
  templateUrl: './alarm-item-menu.component.html',
  styleUrls: ['./alarm-item-menu.component.scss']
})
export class AlarmItemMenuComponent implements OnInit {

  @Input() public alarm: AlarmMessage;
  @Output() public alarmRemoved = new EventEmitter<void>();
  @ViewChild('ttip') private ttip: TooltipDirective;
  public locateRows: { label: string, feature: MapElement<Geometry> }[] = [];
  public disabledByUser: boolean;
  public hasUserRightsToDisableAlarm: boolean = this.authService.hasPermission('alarmmanipulator');

  constructor(
    private alarmService: AlarmService,
    private mapService: MapService,
    private automationService: AutomationService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.disabledByUser = !isAlarmActiveForUser(this.alarm?.metadata);
  }

  public setAlarmActivity(alarm: AlarmMessage, isActive: boolean) {
    if (!this.hasUserRightsToDisableAlarm) {
      return;
    }
    this.ttip.close();
    this.alarmService.setAlarmActiveStatus(alarm.metadata?._id, isActive)
      .subscribe({
        next: () => this.alarmRemoved.next(),
        error: console.warn
      });
  }

  public focusMarker(feature: MapElement<Geometry>) {
    if (feature?.geometry.type === 'Point') {
      // Make sure marker's layer is visible
      feature.layer.setVisibility(true);
      // Set marker selected / highlighted
      this.mapService.changeCurrentFeature(feature);
      const [lng, lat] = feature.geometry.coordinates;
      this.mapService.flyTo({ lng, lat });
    }
  }

  public openMenu(event: MouseEvent, tooltip: TooltipDirective) {
    this.onTooltipOpen();
    console.warn('Open menu', event, tooltip);
    tooltip.open({
      alarm: this.alarm,
      event
    });
  }

  private async onTooltipOpen() {
    this.locateRows = [];
    if (this.alarm.metadata.type === 'vrShiftConflict'
      || this.alarm.metadata.type === 'vrTrainConflict') {
      // Conflict alarms have two locations
      const id1 = this.alarm.metadata.payload.trainDate + '_' + this.alarm.metadata.payload.tripNumber;
      const id2 = this.alarm.metadata.payload.dependentTrainDate + '_' + this.alarm.metadata.payload.dependentTripNumber;
      const f1 = this.mapService.getFeatureById(id1);
      const f2 = this.mapService.getFeatureById(id2);
      this.locateRows = [
        ...this.locateRows,
        ...f1 ? [{ label: `${f1.properties?.title}${f1.properties?.subTitle}`, feature: f1 }] : [],
        ...f2 ? [{ label: `${f2.properties?.title}${f2.properties?.subTitle}`, feature: f2 }] : [],
      ];
    } else if (this.alarm.metadata.type === 'miproMeasure') {
      const id = AlarmService.getIdentifier(this.alarm.metadata);
      const regoId = await this.automationService.getRegoIdForAutomationId(id);
      const feature = this.mapService.getFeatureById(regoId);
      this.locateRows = [
        ...this.locateRows,
        ...feature ? [{ label: feature.properties.description, feature }] : []
      ];
    } else { // Single location
      const id = AlarmService.getIdentifier(this.alarm.metadata);
      const feature = this.mapService.getFeatureById(id);
      if (!!feature) {
        const label = `${feature.properties?.title} ${feature.properties?.subTitle}`;
        this.locateRows = [
          ...this.locateRows,
          ...feature ? [{ label, feature }] : []
        ];
      }
    }
  }

}